import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  tags: string[];
}

export default function MovieCard({ id, title, category, year, rating, image, tags }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={image}
          alt={title}
          title={`${title} - 蘑菇影视`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-white text-xs line-clamp-2 leading-relaxed">
              点击查看详情
            </p>
          </div>
        </div>
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {rating}
        </div>
        <div className="absolute top-2 left-2 bg-background-950/70 text-background-50 text-xs px-2 py-1 rounded-md">
          {year}
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}